/**
 * Shared between the server plugin and the client plugin, which are compiled
 * into different apps and would otherwise drift apart silently — a renamed path
 * on one side produces a 404 at runtime, not a build error.
 */
export const IMPERSONATE_PATH = '/impersonate-user';
export const STOP_IMPERSONATING_PATH = '/stop-impersonating';

/**
 * The HTTP method of each endpoint, declared once and read by both halves.
 *
 * The client needs this at *runtime*, and `$InferServerPlugin` cannot supply it
 * — it is a type, erased at build. So BetterAuth's client proxy guesses from
 * the arguments instead: a body means POST, no body means GET
 * (`better-auth/dist/client/proxy.mjs`, `getMethod`). `stopImpersonating()`
 * takes no arguments, so without an explicit declaration it goes out as
 * `GET /stop-impersonating` and the POST-only endpoint answers 404 — with
 * nothing in the types to suggest anything is wrong.
 *
 * Declared here rather than repeated on each side so the two cannot disagree:
 * the server reads it for `method`, the client for `pathMethods`.
 */
export const PATH_METHODS = {
  [IMPERSONATE_PATH]: 'POST',
  [STOP_IMPERSONATING_PATH]: 'POST',
} as const;

/**
 * Holds the admin's own session token while they are impersonating, so
 * `/stop-impersonating` can put them back. Signed with `BETTER_AUTH_SECRET`.
 */
export const ADMIN_SESSION_COOKIE = 'admin_session';

/** One hour. Impersonation should expire on its own if someone walks away. */
export const DEFAULT_SESSION_DURATION_SECONDS = 60 * 60;
